export const truncateDescription = (desc) => {
  const words = desc.split(" ");
  const truncatedWords = words.slice(0, 20);
  return truncatedWords.join(" ") + (words.length > 60 ? "..." : "");
};